import React                 from 'react';
import { isNullOrUndefined } from 'rewire-common';
import { Observe }           from 'rewire-core';
import { IGridFontSizes }    from 'rewire-grid';
import { WithStyle }         from 'rewire-ui';
import { Theme }             from '@material-ui/core/styles';
import Typography            from '@material-ui/core/Typography';
import Grid                  from '../ui/Grid';
import Loader                from '../ui/Loader';
import TimeOffInfoPanel      from './TimeOffInfoPanel';
import TimeOffToolbar        from './TimeOffToolbar';
import timeOffModel          from './TimeOffModel';
import { withStyles }        from '../utility/styles';

const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    minHeight: '140px',
  },
  timeOffContainer: {
    display: 'flex',
    flex: '1 1 auto',
    minWidth: '508px',
    flexDirection: 'column',
  },
  loading: {
    height: '100%',
    cursor: 'wait',
  },
  gridLeftLabels: {
    borderRight: `1px solid ${theme.palette.primary.light}`,
  },
  gridCornerLabels: {
    borderRight: `1px solid ${theme.palette.primary.light} !important`,
  },
  cellInnerContainer: {
    padding: '0px',
  },
});

interface ITimeOffProps {
}

type TimeOffProps = WithStyle<ReturnType<typeof styles>, ITimeOffProps>;

class TimeOff extends React.Component<TimeOffProps> {
  constructor(props: TimeOffProps) {
    super(props);
  }

  componentWillUnmount() {
    timeOffModel.deactivate();
    timeOffModel.reset();
  }

  renderTimeOffGrid = React.memo((): JSX.Element => {
    const gridFontSizes: IGridFontSizes = {
      header:     '0.9em',
      body:       '0.85em',
      groupRow:   '1em',
      toggleMenu: '0.9em',
    };
    return (
      < >
      <Observe render={() => (
          <Loader loading={timeOffModel.isLoading}>
            <Observe render={() => (
              (timeOffModel.hasResults || timeOffModel.hasRows)
                ? !isNullOrUndefined(timeOffModel.grid.id) &&
                  <Grid key={timeOffModel.grid.id} grid={timeOffModel.grid} gridFontSizes={gridFontSizes} classes={{leftLabels: this.props.classes.gridLeftLabels, cornerLabels: this.props.classes.gridCornerLabels}} cellClasses={{cellInnerContainer: this.props.classes.cellInnerContainer}} /> || null
                : !timeOffModel.isLoading && <Typography variant='h5'>No Results</Typography>

            )} />
          </Loader>
      )}/>
      </>
    );
  });

  render() {
    const {classes} = this.props;

    return <Observe render={() => (
      <div className={classes.root}>
        <div className={classes.timeOffContainer}>
          <TimeOffToolbar />
          <this.renderTimeOffGrid />
        </div>
        <TimeOffInfoPanel />
      </div>
    )} />;
  }
}

export default withStyles<ITimeOffProps>(styles, TimeOff);
